import {spotheroPatch} from 'api';
import {MonthlyRate, MonthlyRateResponse} from 'api/rates/rates.types';
import {stripHtml} from 'string-strip-html';
import {camelizeKeys, convertKeysToSnakeCase} from 'utils/format-strings';

/**
 * Formats the request to update a monthly rate.
 */
const formatUpdateMonthlyRateRequest = (data: Partial<MonthlyRate>) => {
    const request: Partial<MonthlyRateResponse> = convertKeysToSnakeCase(data);

    return request;
};

/**
 * Formats the response from updating a monthly rate.
 */
const formatUpdateMonthlyRateResponse = (
    response: MonthlyRateResponse
): MonthlyRate => {
    const camelizedResponse: MonthlyRate = camelizeKeys(response);

    const formattedResponse = {
        ...camelizedResponse,
        description: stripHtml(camelizedResponse.newDescription).result,
    };

    return formattedResponse;
};

export interface UpdateMonthlyRateParams {
    facilityId: number;
    ruleId: number;
    rateData: Partial<MonthlyRate>;
}

/**
 * Updates a monthly rate.
 * @see https://spothero.com/api/v1/docs/endpoints/?new-docs=true#!/Facilities/patch_facilities_facility_id_monthly_rental_rules_monthly_rental_rule_id
 */
const updateMonthlyRate = async (data: UpdateMonthlyRateParams) => {
    const {facilityId, ruleId, rateData} = data;
    const formattedRequest = formatUpdateMonthlyRateRequest(rateData);

    const response = await spotheroPatch<MonthlyRateResponse>(
        `facilities/${facilityId}/monthly-rental-rules/${ruleId}/`,
        formattedRequest
    );
    const formattedResponse = formatUpdateMonthlyRateResponse(
        response.data.data
    );

    return formattedResponse;
};

export default updateMonthlyRate;
